(function() {
    fp.client = {
        //cache: {
        //    menuItemHash: {}
        //}
        //,bindInitializedEvent: function() {
        //    $(fp.client).on(fp.events.INITIALIZED, onClientEventPassThrough);
        //    bindClientEvent(fp.events.INITIALIZED);
        //}
        initClientEvents: function() {
            //set up pass through client bindable events (all client events will go through onClientEventPassThrough)
            var $fpClient = $(fp.client);
            _.each(fp.clientEvents.on, function(value, key) {
                $fpClient.on(key, onClientEventPassThrough);
            });

            _.each(fp.clientUiEvents.on, function(value, key) {
                $fpClient.on(key, onUiClientEventPassThrough);
            });

            var dataEvents = fp.data.events;

            //bind any events that have been stored while freshop core was loading
            bindClientEvent(dataEvents.handlers);
            bindClientEvent(dataEvents.uiHandlers);

            dataEvents.queue = {};
            dataEvents.uiQueue = {};

            var handler = function (event, data) {
                    dataEvents.queue[fpUtil.getEventNs(event)] = {event: event, data: data};
                },
                uiHandler = function (event, data) {
                    dataEvents.uiQueue[fpUtil.getEventNs(event)] = {event: event, data: data};
                };

            fp.clientCallbackReady = function () {
                $(function() {
                    var delay = 100;

                    //removeIf(!debug)

                    // delay = fpUi.router.routeManager.urlParams.client_callback_hang_for || delay;

                    //endRemoveIf(!debug)

                    // trigger queued events from timeout after document.ready to ensure any freshop events
                    // bound from document.ready are triggered
                    _.delay(function() {
                        fp.log('Client callback ready');
                        
                        _.each(fp.clientEvents.on, function(value, key) {
                            fp.off(key, handler);
                        });

                        _.each(fp.clientUiEvents.on, function(value, key) {
                            fp.off(key, uiHandler);
                        });

                        _.each(dataEvents.queue, function(item) {
                            onClientEventPassThrough(item.event, item.data);
                        });

                        _.each(dataEvents.uiQueue, function(item) {
                            onUiClientEventPassThrough(item.event, item.data);
                        });

                        delete fp.data;
                    }, delay);
                });

                delete fp.clientCallbackReady;
                delete fp.clientCallback;
                delete fp.clientReady;
            };

            if (fp.clientReady) fp.clientCallbackReady();
            else if (fp.clientCallback) {
                //if a client callback has been assigned, listen for and store
                //all events until after the client callback has been triggered

                for (var key in fp.clientEvents.on) {
                    fp.on(key, handler);
                }

                for (var key in fp.clientUiEvents.on) {
                    fp.on(key, uiHandler);
                }
            }
        }
    };

    function bindClientEvent(event) {
        var dataEvents = fpUtil.getNamespace('data.events', fp),
            eventHandlers = dataEvents.handlers,
            uiEventHandlers = dataEvents.uiHandlers;

        if(!eventHandlers && !uiEventHandlers) return;

        var events = _.isString(event) ? [event] : event;

        _.each(events, function(item, key) {
            if(_.isString(item)) key = item;

            if(eventHandlers) {
                _.each(eventHandlers[key], function (item) {
                    if (fp.clientEvents.on[item.event]) freshop.on(item.event, item.callback);
                });
            }

            if(uiEventHandlers) {
                _.each(uiEventHandlers[key], function (item) {
                    if (fp.clientUiEvents.on[item.event]) freshop.ui.on(item.event, item.selector, item.callback);
                });
            }

            if(eventHandlers) delete eventHandlers[key];
            if(uiEventHandlers) delete uiEventHandlers[key];
        });
    }

    //function onStoreChanged(event, data) {
    //    if(!fp.loaded) {
    //        onClientEventPassThrough(event, data);
    //        return;
    //    }
    //
    //    fp.one(fp.events.DEPARTMENTS_LOADED, function() {
    //        onClientEventPassThrough(event, data);
    //    });
    //}

    //set up pass through client bindable events (all client events will go through onClientEventPassThrough)
    function onClientEventPassThrough(event, data) {
        var eventNs = fpUtil.getEventNs(event);

        //removeIf(!debug)

        // if(fp.disableRender && eventNs != fp.events.INITIALIZED) return;

        //endRemoveIf(!debug)

        //fp.log('onClientEventPassThrough', eventNs, data);
        //fp.log('fp.clientEvents.on[' + eventNs + ']', fp.clientEvents.on[eventNs]);
        if(eventNs == fp.events.STORE_CHANGED) {
            //remove this when Wordpress replaces STORE_LOADED with STORE_CHANGED
            event = eventNs = fp.events.STORE_LOADED;
        }

        if(fp.clientEvents.on[eventNs]) {
            try {
                $(freshop).trigger(event, data);
            }
            catch(exc) {
                fp.notifier.notify(exc);
            }
        }
    }

    //set up pass through client bindable events (all UI client events will go through onUiClientEventPassThrough)
    function onUiClientEventPassThrough(event, data) {
        var eventNs = fpUtil.getEventNs(event);

        //removeIf(!debug)
        
        // if(fp.disableRender && eventNs != fp.events.LOADED) return;

        //endRemoveIf(!debug)

        //fp.log('onUiClientEventPassThrough', eventNs, event, data);
        // fp.log('fp.clientUiEvents.on[' + eventNs + ']', fp.clientUiEvents.on[eventNs]);

        if(fp.clientUiEvents.on[eventNs]) {
            switch(eventNs) {
                //track event is special and should only be triggered if target is default scope
                case fp.events.TRACK_EVENT:
                    if(event.target.__type == fp.defaultScope.__type) return;
                    break;
                case fp.events.RENDERED:
                    var $target = $(event.target),
                        events = $._data(freshop.ui, 'events');

                    if($target.length && events) {
                        var $element;
                        _.each(events.rendered, function (item) {
                            $element = null;

                            if(item.selector) {
                                try {
                                    $element = $target.filter(item.selector);
                                }
                                catch(exc){}
                            }

                            if (!($element && $element.length)) return;

                            item.handler.call(freshop.ui, event);
                        });
                    }
                    return;
            }

            try {
                $(freshop.ui).trigger(event, data);
            }
            catch(exc) {
                fp.notifier.notify(exc);
            }
        }
    }
})();